import { SizeScale } from "rtr-constants";

export const isOneSize = skus => skus?.length === 1 && skus[0]?.sizeDisplayText === SizeScale.ONE_SIZE;
